import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { Chart } from 'chart.js';
import { FormatCo2eService } from 'src/app/shared/services/format-co2e.service';

@Component({
  selector: 'app-custom-progress-bar',
  templateUrl: './custom-progress-bar.component.html',
  styleUrl: './custom-progress-bar.component.scss',
  standalone: false,
})
export class CustomProgressBarComponent implements OnInit, OnChanges {
  @Input() inputRatio!: number;
  @Input() impactPerTraveller?: number;
  ratio: number = 0;
  color: string = '#B1B5B1'; // greyscale-400 - couleur cohérente
  backgroundColor = '#E3E7E3'; // greyscale-200 - fond cohérent
  data = {};
  tooltip: string = 'impact :';

  setColor() {
    const rootStyle = getComputedStyle(document.documentElement);
    switch (true) {
      case this.inputRatio > 2:
        this.color = rootStyle.getPropertyValue('--color-dark-red').trim();
        this.backgroundColor = rootStyle
          .getPropertyValue('--color-bright-red')
          .trim();
        break;
      case this.inputRatio > 1:
        this.color = rootStyle.getPropertyValue('--color-bright-red').trim();
        this.backgroundColor = rootStyle
          .getPropertyValue('--color-dark-orange')
          .trim();
        break;
      default:
        this.color = rootStyle.getPropertyValue('--color-primary-500').trim();
        this.backgroundColor = rootStyle
          .getPropertyValue('--color-primary-400')
          .trim();
    }
  }
  setRatio() {
    if (this.inputRatio > 3 || this.inputRatio % 1 === 0) {
      this.ratio = 1;
    } else {
      this.ratio = this.inputRatio % 1;
    }
  }

  ngOnInit() {
    this.setColor();
    this.setRatio();
    this.updateData();
  }
  ngOnChanges() {
    this.setColor();
    this.setRatio();
    this.updateData();
  }
  private formatCo2e = inject(FormatCo2eService);

  getLabel() {
    return this.formatCo2e.format(this.impactPerTraveller ?? 0);
  }
  updateData() {
    this.data = {
      labels: ['impact'],
      datasets: [
        {
          data: [this.ratio],
          backgroundColor: [this.color],
          borderSkipped: false,
          borderRadius: 1000,
          barPercentage: 1,
          categoryPercentage: 1,
        },
      ],
    };
  }
  options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: () => {
            return this.getLabel(); // Texte personnalisé
          },
        },
      },
    },

    scales: {
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
        border: {
          display: false,
        },
      },
      x: {
        min: 0,
        max: 1,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
  };

  plugins = [
    {
      id: 'progressBar',
      beforeDatasetsDraw: (chart: Chart) => {
        const {
          ctx,
          chartArea: { left, width, height },
          scales: { y },
        } = chart;
        ctx.save();
        const barHeight = height / y.ticks.length;
        const borderRadius = barHeight / 2;
        ctx.beginPath();
        ctx.fillStyle = this.backgroundColor;

        // Applique un rectangle avec un borderRadius dynamique
        ctx.moveTo(left + borderRadius, y.getPixelForValue(0) - barHeight / 2);
        ctx.lineTo(
          left + width - borderRadius,
          y.getPixelForValue(0) - barHeight / 2,
        );
        ctx.arc(
          left + width - borderRadius,
          y.getPixelForValue(0),
          borderRadius,
          1.5 * Math.PI,
          0.5 * Math.PI,
        );
        ctx.lineTo(left + borderRadius, y.getPixelForValue(0) + barHeight / 2);

        ctx.arc(
          left + borderRadius,
          y.getPixelForValue(0),
          borderRadius,
          0.5 * Math.PI,
          1.5 * Math.PI,
        );
        ctx.fill();
      },
    },
  ];
}
